import { useMemo } from 'react';

export const useHasHistory = () => useMemo(() => Boolean(window.history.state), []);
